import { RoomEntity, UserEntity } from '@mentessa/types';

export function getDirectMember(room: RoomEntity, me: UserEntity) {
  return room?.members.find((rm) => rm.user?.id !== me?.id)?.user;
}
